var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$fetchState.pending && _vm.story.content.component)?_c('page',{key:_vm.story.content._uid,attrs:{"name":_vm.story.name,"story":_vm.story}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }